/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamShapingGroupCircularDto } from './BeamShapingGroupCircularDto';
import {
    instanceOfBeamShapingGroupCircularDto,
    BeamShapingGroupCircularDtoFromJSON,
    BeamShapingGroupCircularDtoFromJSONTyped,
    BeamShapingGroupCircularDtoToJSON,
} from './BeamShapingGroupCircularDto';
import type { BeamShapingGroupRectangularDto } from './BeamShapingGroupRectangularDto';
import {
    instanceOfBeamShapingGroupRectangularDto,
    BeamShapingGroupRectangularDtoFromJSON,
    BeamShapingGroupRectangularDtoFromJSONTyped,
    BeamShapingGroupRectangularDtoToJSON,
} from './BeamShapingGroupRectangularDto';

/**
 * @type BeamShapingGroupDto
 * 
 * @export
 */
export type BeamShapingGroupDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamShapingGroupCircularDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamShapingGroupRectangularDto;


export function BeamShapingGroupDtoFromJSON(json: any): BeamShapingGroupDto {
    return BeamShapingGroupDtoFromJSONTyped(json, false);
}

export function BeamShapingGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamShapingGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...BeamShapingGroupCircularDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...BeamShapingGroupRectangularDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of BeamShapingGroupDto exists with '$type=${json['$type']}'`);
    }
}

export function BeamShapingGroupDtoToJSON(value?: BeamShapingGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamShapingGroupCircularDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamShapingGroupRectangularDtoToJSON(value);
        default:
            throw new Error(`No variant of BeamShapingGroupDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the BeamShapingGroupDto interface.
 */
export function instanceOfBeamShapingGroupDto(value: any): value is BeamShapingGroupDto {
    if (instanceOfBeamShapingGroupCircularDto(value)) return true;
    if (instanceOfBeamShapingGroupRectangularDto(value)) return true;
    return false;
}

